<template>
    
    <div class="w-full h-auto mb-32">

        <div class="h-56 z-0" style="background-image: url(https://genesis.zeus.vision/assets/valentina/img/header3.jpg); background-repeat: no-repeat; background-size: cover; background-position: center; position: sticky; top:0; height:33vh;"></div>

        <div class="h-auto w-11/12 rounded-lg shadow-3xl mx-auto z-30 -mt-24 bg-white flex flex-col overflow-hidden relative"> 

            <All model="orders" :immediate="false" :query="query" v-slot="{data,loading}" ref="orders">

                <div v-if="!loading" class="h-auto flex flex-col overflow-hidden mb-2">

                    <div class="h-auto w-full flex flex-row justify-center items-end border-b pt-4">
                        <span class="text-gray-500 font-semibold text-3xl">Pedidos</span>
                    </div>

                    <div class="flex-1" v-if="data.data">

                        <order v-for="(el,index) in data.data.orders" :data="el" :key="index"></order>

                    </div>
                    
                    <div class="h-8 w-full flex flex-row justify-center items-center">

                        <div class="h-full w-1/3 mr-2 flex flex-row justify-center items-center" @click="prevPage()">
                        
                            <i class="mdi mdi-arrow-left text-sm" :class="{'text-gray-500': page == 1, 'text-blue-500': page > 1}"></i>

                        </div>

                        <div class="h-8 w-8 rounded-full bg-blue-400 flex flex-row justify-center items-center shadow">
                            <span class="text-white">{{page}}</span>
                        </div>

                        <div class="h-full w-1/3 ml-2 flex flex-row justify-center items-center" @click="nextPage()">
                        
                            <i class="mdi mdi-arrow-right text-sm" :class="{'text-blue-500': page}"></i>

                        </div>

                    </div>

                </div>

            </All>

        </div>

    </div>

</template>

<script>
import filters from './filters.vue';
import sale from './sale.vue';
import chartarea from './chartarea.vue';
import { state,actions } from '../store/store.js';
import order from './order.vue';
import { All } from '@/api/components';

export default {
    components:{
        filters,
        sale,
        chartarea,
        order,
        All
    },
    data(){
        return{
            page: 1
        }
    },
    methods:{
        prevPage(){
            
            if(this.page>1){
                this.page--
            }

        },
        nextPage(){
            
            this.page++

        }
    },
    computed:{
        period(){
            return state.period
        },
        query(){
            if(state.period != 'custom' && !state.dates){

                return {
                    period: state.period,
                    store: state.store,
                    page: this.page
                }

            } else {

                if(state.dates == null){

                    return{
                        period: state.period,
                        store: state.store,
                        page: this.page
                    }

                } else {

                    return{
                        period: state.period,
                        store: state.period,
                        from: state.dates.start,
                        to: state.dates.end,
                        page: this.page
                    }

                }

            }
        }
    },
    watch:{
        page(){
            this.$refs['orders'].request();
        }
    },
    mounted(){
        this.$refs['orders'].request();
    }
}
</script>